///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const DownloadIcon = ({
  className,
  height,
  title = messages.download.defaultMessage,
  width,
  fill = "#343434",
  ...rest
}) => (
  <svg
    aria-labelledby="download-icon"
    className={className}
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title id="download-icon">{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-2-2h16v16H-2z" />
      <path
        fill={fill}
        fillRule="nonzero"
        d="M11 5l-.881-.881-3.494 3.487V0h-1.25v7.606L1.888 4.112 1 5l5 5z"
      />
      <path fill={fill} d="M0 11h12v1.33H0z" />
    </g>
  </svg>
);

export default DownloadIcon;
